import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";

export interface IOrdersDatatableRowFormMeta {
  creationDate: FormInputMeta,
  order: FormInputMeta,    
  reason: FormInputMeta,
  tag: FormInputMeta,
  oldValue: FormInputMeta,
  newValue: FormInputMeta,
  status: FormInputMeta,
  active: FormInputMeta,
  //
  schema: any,
}

const OrdersDatatableRowFormMeta = {} as IOrdersDatatableRowFormMeta;

OrdersDatatableRowFormMeta.creationDate = {
  name: 'creationDate',
  type: 'date',
  label: 'Date creation',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
OrdersDatatableRowFormMeta.order = {
  name: 'order',
  type: 'text',
  label: 'Commande',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
OrdersDatatableRowFormMeta.reason = {
  name: 'reason',
  type: 'text',
  label: 'Motif',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
OrdersDatatableRowFormMeta.tag = {
  name: 'tag',
  type: 'text',
  label: 'Tag',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
OrdersDatatableRowFormMeta.oldValue = {
  name: 'oldValue',
  type: 'text',
  label: 'Ancienne valeur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
OrdersDatatableRowFormMeta.newValue = {
  name: 'newValue',
  type: 'text',
  label: 'Nvelle Valeur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
OrdersDatatableRowFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
OrdersDatatableRowFormMeta.active = {
  name: 'active',
  type: 'checkbox',
  label: 'Active',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};


OrdersDatatableRowFormMeta.schema = yup.object().shape(getValidationSchema(OrdersDatatableRowFormMeta));

export default OrdersDatatableRowFormMeta;
